<template>
<router-view></router-view>
</template>



<style lang="scss">
@import '@/assets/scss/style.scss';
</style>
